import ToolsPage_ from './ToolsPage';

export default ToolsPage_;
